import React, { Fragment } from "react";
import {
  arrayOf,
  number,
  objectOf,
  oneOfType,
  string,
  shape
} from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  IconButton,
  Button,
  Tooltip
} from "@material-ui/core";
import format from 'date-fns/format';
import addSeconds from 'date-fns/add_seconds';
import moment from "moment";
import cx from "classnames";
import styles from "./styles.scss";
import ReassignModal from "components/Modal/ReassignModal";
import veritoneApi from '../../../../helpers/veritoneApi';
import {
  Visibility,
  Videocam,
  Mic,
  ExpandMore,
  ExpandLess,
  Shuffle,
  VisibilityOff,
  ArrowBack,
  ArrowUpward,
  Cancel,
  ChevronRight,
  ArrowDownward,
  KeyboardArrowDown,
  Reply as ReplyIcon
} from "@material-ui/icons";
import _ from "lodash";
import PlayerMedia from "../../../../components/Media";
import InfiniteScroll from "react-infinite-scroll-component";
import { AD_TYPE_ID, EXCLUDE, STATION_CHART_ID, INCLUDE, REASSIGNED, ADTYPE_CHART_ID, ADVISIT_CHART_ID } from "../../../../helpers/constant";
import { checkRole, normalizeTimeRange } from "../../../../helpers/formatData";
import { DISCOVERY_EDITOR } from "../../../../helpers/constant";
import {
  defaultGroupLevel,
  groupLevel3,
  groupLevel4,
  groupLevel5
} from "./dataTableFixed";
const AUDIO = 1;
const VIDEO = 2;

const SUMMARY_STYLES = {
  customTooltip: {
    fontSize: 14,
    padding: "10px",
  },
  arrowIcon: {
    fontSize: 16,
    margin: '0px 0px 2px 5px',
  },
  checkbox: {
    padding: 12,
  },
  tableCheckbox: {
    padding: 12,
    position: 'absolute'
  },
    sortByButton: {
    borderRadius: '100px',
    backgroundColor: '#e0e0e0',
    textTransform: 'none',
    padding: '5px 10px 5px 20px',
    marginRight: '20px',
    marginTop: '-7px',

    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)'
    },

    '& span > *': {
      paddingLeft: '2px',
      color: 'rgba(0, 0, 0, 0.87)',
      fontFamily: 'Nunito',
      fontSize: '14px',

      '&:nth-child(2)': {
        color: '#9d9c9d',
        fontSize: '24px'
      },

      '&:nth-child(1)': {
        fontSize: '24px'
      }
    }

  }
};

const MAX_HEADER_CAN_GROUP = 6; // max number of header can multigroup at one time

export class SummaryDrillDown extends React.Component {
  static propTypes = {
    headerMaps: objectOf(string),
    mentions: arrayOf(objectOf(oneOfType([string, number]))),
    orderBy: string,
    order: string,
    roles: arrayOf(objectOf(string)),
    config: shape({
      urlApi: objectOf(string)
    })
  };

  state = {
    openReassignModal: false,
    selected: [],
    showDropArea: false,
    groupBy: "",
    sortBy: "desc",
    mentionsGrouped: [],
    mentionScrollToShow: [],
    scrollSectionIndex: 1,
    itemsPerScrolling: 20,
    hasMore: true,
    orderBy: "",
    order: "",
    groupByArr: [],
    dataAfterGroup: [],
    marginBlockHeader: 0,
    mediaMentionId: null,
    defaultValue: defaultGroupLevel
  }

  static getDerivedStateFromProps(props, state) {
    if (props.isResetAfterDone) {
      props.resetAfterDone();
      return {
        ...state,
        selected: [],
      }
    }
    return {
      ...state
    }
  }

  componentDidMount = () => {
    document.addEventListener("keydown", this.handleKeyDown);
    const { itemsPerScrolling } = this.state;
    const { mentions } = this.props;
    this.setState({
      mentionScrollToShow: mentions.slice(0, itemsPerScrolling)
    })
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { mentions, handleGrouping } = this.props;
    const { itemsPerScrolling, scrollSectionIndex, groupByArr } = this.state;
    const { groupByArr: prevGroupByArr, mentionScrollToShow: prevMentionScrollToShow } = prevState;
    let mentionScrollToShow = mentions.slice(0, itemsPerScrolling * scrollSectionIndex);
    if (groupByArr.length > 0) {
      mentionScrollToShow = mentions;
    }
    if (groupByArr.length > 0 && prevGroupByArr.length === 0 || groupByArr.length === 0 && prevGroupByArr.length > 0) {
      this.setState({
        mentionScrollToShow
      })
    }
    if (!_.isEqual(mentions, prevProps.mentions) || !_.isEqual(mentionScrollToShow, prevMentionScrollToShow)) {
      const dataAfterGroup = this.groupMentions(groupByArr, mentionScrollToShow);
      this.setState({
        dataAfterGroup,
        mentionScrollToShow
      })
    }
    if (groupByArr.length !== prevState.groupByArr.length) {
      handleGrouping(groupByArr.length > 0);
    }
  }

  componentWillUnmount = () => {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  setLoadingLeft = () => {
    this.setState({
      isLoadSuccessLeft: false
    });
  }

  setLoadingRight = () => {
    this.setState({
      isLoadSuccessRight: false,
      hiddenRightButton: false
    });
  }

  // currently we are still making two calls to get mediasource due to component set up
  // TODO: remove this when refactor the component
  getMediaContent = (mention) => {
    const { airtime, collected_date, station_id } = mention;
    const normalized = normalizeTimeRange(airtime, collected_date);
    return `query getMediaInfo {
      searchMedia(search: {
        index: ["mine"],
        limit: 1,
        offset: 0,
        query: {
          operator: "and",
          conditions: [
            {
              operator: "and"
              conditions:
              [
                { operator: "range", field: "absoluteStartTimeMs", gte: "${normalized.airtime}"},
                { operator: "range", field: "absoluteStopTimeMs", lte: "${normalized.collected_date}"}
              ]
            },
            {
              field: "mediaSourceId",
              operator: "terms",
              values: [${String(station_id)}]
            }
          ]}
        }
      )
      {
        jsondata
      }
    }`;
  }

  getMediaSource = (mention) => {
    const { config } = this.props;
    const { mention_id, airtime, collected_date, station_id } = mention;
    return veritoneApi(config.urlApi.graphql).post('', { query: this.getMediaContent(mention) })
      .then(response => {
        const data = _.get(response, "data.data.searchMedia.jsondata.results.0.recording");
        const mediaMention = data ? {
          ...data,
          mention_id,
          airtime,
          collected_date,
          station_id
        } : undefined;

        this.setState({
          mediaMention,
          mediaMentionId: mention_id
        });

        return mediaMention;
      })
      .catch(error => error);
  }

  getChangeTime = (time, seconds) => {
    const timeChange = addSeconds(new Date(time), seconds);
    const timeFormat = moment.utc(timeChange).format('YYYY-MM-DDTHH:mm:ss.SSS');
    return `${timeFormat}Z`;
  }

  openSourceVideo = mention => event => {
    let { mediaMentionId } = this.state;
    if (mediaMentionId === mention.mention_id) {
      return this.setState({
        mediaMentionId: null,
        mediaMention: null
      });
    }
    this.getMediaSource(mention);
  };

  handleToggleItem = (mentionId, mentionStatus) => event => {
    event.stopPropagation();
    this.props.handleToggleMention(mentionId, mentionStatus);
  }

  handleClickReassignMention = mentionsToReassign => event => {
    event.stopPropagation();
    this.handleReassignMention(mentionsToReassign);
  }

  handleReassignMention = mentionsToReassign  => {
    this.setState({
      openReassignModal: true,
      mentionsToReassign
    })
  }

  handleCloseReassignDialog = () => {
    this.setState({
      openReassignModal: false
    })
  }


  handleSelectAllClick = event => {
    this.props.resetAfterDone();
    const { mentions } = this.props;
    if (event.target.checked) {
      return this.setState({ selected: mentions.map(mention => mention.gen_key) });
    }
    this.setState({ selected: [] });
  };

  handleBackAllCheck = () => {
    this.setState({ selected: [] })
  }

  handleSelectCheckbox = id => event => {
    event.stopPropagation();
    this.props.resetAfterDone();
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  }

  handleClickHeader = () => {
    this.setState(state => ({
      showDropArea: !state.showDropArea
    }))
  }

  onDragToGroupMentionStart = headerKey => event => {
    event.dataTransfer.setData("text", headerKey);
    const targetHeader = document.getElementById(`key-${headerKey}`);

    const currentBackground = targetHeader.style.background;
    const currentBorderRadius = targetHeader.style.borderRadius;
    const currentWidth = targetHeader.style.width;
    const currentDisplay = targetHeader.style.display;
    const currentPadding = targetHeader.style.padding;

    targetHeader.style.background = '#e0e0e0';
    targetHeader.style.borderRadius = '100px';
    targetHeader.style.padding = '8px 20px';
    targetHeader.style.display = 'inline-block';
    targetHeader.style.width = 'unset';

    setTimeout(() => {
      targetHeader.style.background = currentBackground;
      targetHeader.style.padding = currentPadding;
      targetHeader.style.display = currentDisplay;
      targetHeader.style.width = currentWidth;
      targetHeader.style.borderRadius = currentBorderRadius;
    }, 1)
  }

  dropToGroupMention = event => {
    event.preventDefault();
    const newGroupBy = event.dataTransfer.getData("text");
    const { groupByArr } = this.state;
    if (groupByArr.length === MAX_HEADER_CAN_GROUP) {
      return;
    }
    const newGroupByArr = [
      ...groupByArr,
      {
        groupBy: newGroupBy,
        sortBy: "asc"
      }
    ]
    const dataAfterGroup = this.groupMentions(newGroupByArr);
    this.setState({
      groupByArr: newGroupByArr,
      dataAfterGroup
    })
    // process default value
    let groupLevel = groupByArr.length + 1;
    switch(groupLevel){
      case 3:
        this.setState({
          defaultValue: groupLevel3
        })
        break;
      case 4:
      this.setState({
        defaultValue: groupLevel4
      })
      break;

      case 5:
        this.setState({
          defaultValue: groupLevel5
        })
        break;
      default:
        this.setState({
          defaultValue: defaultGroupLevel
        })
    }
  }

  handleDropToGroupMentionDrag = event => {
    event.preventDefault();
  }

  handleItemsExclude = status => {
    const { selected, groupByArr } = this.state;
    this.props.handleItemsExclude(selected, status);

    if (groupByArr.length) {
      const { selected, mentionsGrouped } = this.state;
      mentionsGrouped.map(mentionGrouped => {
        mentionGrouped.mentionGroupList.map(mention => {
          if (_.includes(selected, mention.gen_key)) {
            mention.status = status
          }
        })
      })

      this.setState({ mentionsGrouped });
    }
  }

  handleClickItemsExclude = status => event => {
    this.handleItemsExclude(status)
  }

  handleClickCloseGroupByButton = (groupBy) => event => {
    event.stopPropagation();
    const { groupByArr } = this.state;
    if (groupByArr.length === 1) {
      const { mentions } = this.props;
      const { itemsPerScrolling, scrollSectionIndex } = this.state;
      const initialMentionScrollToShow = mentions.slice(0, itemsPerScrolling * scrollSectionIndex);
      return this.setState({
        groupByArr: [],
        dataAfterGroup: [],
        mentionScrollToShow: initialMentionScrollToShow
      })
    }
    const newGroupByArr = groupByArr.filter(item => item.groupBy !== groupBy);
    this.setState({
      groupByArr: newGroupByArr,
      dataAfterGroup: this.groupMentions(newGroupByArr)
    })
  }

  showMentionGrouped = indexParam => event => {
    const { mentionsGrouped } = this.state;
    mentionsGrouped.map((mention, index) => {
      if (index === indexParam) {
        mention.isListShowed = !mention.isListShowed
      }
    })
    this.setState({
      mentionsGrouped
    })
  }

  handleSortMentionGrouped = (groupBy) => event => {
    const { groupByArr } = this.state;
    let isCloseAllGroup = false;
    const newGroupByArr = groupByArr.map((item, index) => {
      if (item.groupBy === groupBy) {
        if (index !== groupByArr.length - 1) {
          isCloseAllGroup = true;
        }
        return {
          ...item,
          sortBy: item.sortBy === "asc" ? "desc" : "asc"
        }
      }
      return item
    });
    const dataAfterGroup = this.groupMentions(newGroupByArr, undefined, isCloseAllGroup);
    this.setState({
      dataAfterGroup,
      groupByArr: newGroupByArr
    })
  }

  handleReassignItems = (summaryJobTitle, reassignListChange) => {
    this.handleCloseReassignDialog();
    this.props.handleReassignMentions(summaryJobTitle, reassignListChange)
  }

  getMoreMentions = () => {
    const { mentionScrollToShow } = this.state;
    const { mentions } = this.props
    if (mentionScrollToShow.length >= mentions.length) {
      this.setState({ hasMore: false });
      return;
    }

    setTimeout(() => {
      const {
        scrollSectionIndex,
        mentionScrollToShow,
        itemsPerScrolling
      } = this.state;
      this.setState({
        mentionScrollToShow: mentionScrollToShow.concat(
          mentions.slice(itemsPerScrolling * scrollSectionIndex, itemsPerScrolling * (scrollSectionIndex + 1))
        ),
        scrollSectionIndex: scrollSectionIndex + 1
      });
    }, 500);
  }

  handleKeyDown = event => {
    const { selected } = this.state;
    const { detailUrl, id } = this.props;
    const isAbleToReassign = detailUrl.adType === 'Live Reads' || id === STATION_CHART_ID;

    if (selected.length > 0) {
      const isSelectedAbleToReassign = this.getIsSelectedAbleToReassign();
      const selectedAllStatus = this.getSelectAllStatus();

      if (isAbleToReassign &&
        isSelectedAbleToReassign &&
        (event.metaKey || event.ctrlKey) &&
        (event.keyCode === 82)
      ) {
        event.preventDefault();
        this.handleReassignMention(selected)
      }

      if ((selectedAllStatus !== EXCLUDE) && (event.metaKey || event.ctrlKey) && (event.keyCode === 88)) {
        event.preventDefault();
        this.handleItemsExclude(2)
      }

      if ((selectedAllStatus !== INCLUDE) && (event.metaKey || event.ctrlKey) && (event.keyCode === 81)) {
        event.preventDefault();
        this.handleItemsExclude(1)
      }
    }
  }

  getSelectAllStatus = () => {
    const { selected} = this.state;
    const { mentions } = this.props;
    const excludeMentionsIdList = [];
    const includeMentionsIdList = [];

    for (let i = 0; i < mentions.length; i++) {
      if (mentions[i].status === EXCLUDE) {
        excludeMentionsIdList.push(mentions[i].gen_key);
      }
      if (mentions[i].status === INCLUDE) {
        includeMentionsIdList.push(mentions[i].gen_key);
      }
    }

    let selectedAllStatus = 0;
    if (selected.every(item => excludeMentionsIdList.includes(item))) {
      selectedAllStatus = EXCLUDE;
    }
    if (selected.every(item => includeMentionsIdList.includes(item))) {
      selectedAllStatus = INCLUDE;
    }

    return selectedAllStatus
  }

  getIsSelectedAbleToReassign = () => {
    const { selected } = this.state;
    const { mentions } = this.props;
    let isSelectedNotAbleToReassign = false;
    if (selected.length > 0) {
      for (let i = 0; i < mentions.length; i++) {
        if (_.includes(selected, mentions[i].gen_key) && (mentions[i].status === EXCLUDE || mentions[i].ads_type_id !== AD_TYPE_ID["Live Reads"])) {
          isSelectedNotAbleToReassign = true;
          break;
        }
      }
    }
    return !isSelectedNotAbleToReassign
  }

  handleGroupData = (data, groupBy, prevLoc, prevData = [], isCloseAllGroup) => {
    let result = [];
    let dataGrouped = _.groupBy(data, groupBy.groupBy);
    let listKeys = Object.keys(dataGrouped);
    if (groupBy.groupBy === 'visits') {
      listKeys = listKeys.map(key => parseInt(key))
    }
    const groupValueArrSort = _.orderBy(listKeys, undefined, groupBy.sortBy);
    result = groupValueArrSort.map((key, index) => {
      const newLoc = prevLoc ? [...prevLoc, index] : [index];
      const prevDataInThisLoc = prevData.find(item => item.groupByValue === key);
      const isOpen = _.get(prevDataInThisLoc, 'isOpen');
      return {
        groupByValue: key,
        mentionGroupList: dataGrouped[key],
        groupBy: groupBy,
        currentLoc: newLoc,
        isOpen: isCloseAllGroup ? false : isOpen,
      }
    })
    return result
  }

  addToNewGroup = (data, groupBy, prevData = [], isCloseAllGroup) => {
    return data.map((preGroup, index) => {
      const isOpen = _.get(prevData, [index, 'isOpen']);
      const prevDataToKeep = _.get(prevData, [index, 'groupData']);
      if (preGroup.mentionGroupList) {
        const newGroup = _.omit(preGroup, 'mentionGroupList');
        return {
          ...newGroup,
          isOpen: isCloseAllGroup ? false : isOpen,
          groupData: this.handleGroupData(preGroup.mentionGroupList, groupBy, preGroup.currentLoc, prevDataToKeep, isCloseAllGroup),
        }
      }
      let fixData = this.addToNewGroup(preGroup.groupData, groupBy, prevDataToKeep, isCloseAllGroup);
      return {
        ...preGroup,
        isOpen: isCloseAllGroup ? false : isOpen,
        groupData: fixData,
      }
    })
  }

  groupMentions = (groupByArr, listMentions, isCloseAllGroup) => {
    const { dataAfterGroup: prevData, mentionScrollToShow } = this.state;
    const dataToChange = listMentions ? listMentions : mentionScrollToShow;
    let dataAfterGroup = [];
    if (groupByArr.length !== 0) {
      dataAfterGroup = this.handleGroupData(dataToChange, groupByArr[0], undefined, prevData, isCloseAllGroup);
      for (let i = 1; i < groupByArr.length; i++) {
        dataAfterGroup = this.addToNewGroup(dataAfterGroup, groupByArr[i], prevData, isCloseAllGroup)
      }
    }
    return dataAfterGroup
  }

  renderMentionGrouped = (mentionGroup) => {
    const { headerMaps } = this.props;
    if (!mentionGroup.isOpen) {
      return;
    }
    if (mentionGroup.mentionGroupList) {
      return this.renderMentionListGrouped(mentionGroup);
    }
    return (
      <Fragment>
        {mentionGroup.groupData.map((group, index) => {
          return (
            <Fragment key={`${group.groupByValue} - ${index.toString()}`}>
              <TableRow key={group} className={styles["un-diagonal-section"]}>
                {
                  group.currentLoc.map((loc, subIndex) => (
                    <TableCell key={`${loc} - ${subIndex.toString()}`} className={styles["margin-grouping"]}>
                      {""}
                    </TableCell>
                  ))
                }
                <TableCell colSpan={Object.keys(headerMaps).length + 2} className={styles["table-group-title"]}>
                  <span className={styles["table-checkbox"]}>
                    <IconButton onClick={this.handleOpenMentionGroup(group)}>
                      {group.isOpen ? <KeyboardArrowDown /> : <ChevronRight />}
                    </IconButton>
                  </span>
                  <span>
                    {`${headerMaps[group.groupBy.groupBy]}: ${group.groupByValue}`}
                  </span>
                </TableCell>
              </TableRow>
              {this.renderMentionGrouped(group)}
            </Fragment>
          )
        }
        )
        }
      </Fragment>
    )
  }

  renderMentionGroupedDefault = (mentionGroup) => {
    const { headerMaps } = this.props;
    if (!mentionGroup.isOpen) {
      return;
    }
    if (mentionGroup.mentionGroupList) {
      return;
    }
    return (
      <Fragment>
        {mentionGroup.groupData.map((group, index) => {
          return (
            <Fragment key={`${group.groupByValue} - ${index.toString()}`}>
              <TableRow key={group} className={styles["un-diagonal-section", "color-trans"]}>
                {
                  group.currentLoc.map((loc, subIndex) => (
                    <TableCell key={`${loc} - ${subIndex.toString()}`} className={styles["margin-grouping", "color-trans"]}>
                      {""}
                    </TableCell>
                  ))
                }
                <TableCell colSpan={Object.keys(headerMaps).length + 2} className={styles["table-group-title", "color-trans"]}>
                  <span className={styles["table-checkbox", "color-trans"]}>
                    <IconButton disabled className={styles["color-trans"]} onClick={this.handleOpenMentionGroup(group)}>
                      {group.isOpen ? <KeyboardArrowDown className={styles["color-trans"]}/> : <ChevronRight className={styles["color-trans"]}/>}
                    </IconButton>
                  </span>
                  <span className={styles["color-trans"]}>
                    {`${headerMaps[group.groupBy.groupBy]}: ${group.groupByValue}`}
                  </span>
                </TableCell>
              </TableRow>
              {this.renderMentionGroupedDefault(group)}
            </Fragment>
          )
        }
        )
        }
      </Fragment>
    )
  }

  renderMentionListGrouped = (mentionGroup) => {
    const {
      headerMaps,
      classes,
      id,
      detailUrl,
      roles
    } = this.props;
    const {
      mediaMentionId,
      mediaMention
    } = this.state;
    const isReassigned = detailUrl.adType && detailUrl.adType === 'Live Reads';
    const selectHeaderMaps = ((id === ADTYPE_CHART_ID || id === ADVISIT_CHART_ID) && isReassigned) ? {..._.omit(headerMaps, ["status_reassign"])} : headerMaps;
    const { groupByArr, selected } = this.state;
    const showMediaPlayer = checkRole(roles, DISCOVERY_EDITOR);
    return mentionGroup.mentionGroupList.map((mention, index) => {
      const isReassignedMention = mention.ads_type_id === AD_TYPE_ID["Live Reads"] && mention.status !== EXCLUDE;
      return (
        <Fragment key={mention.mention_id}>
          <TableRow
            key={mention.mention_id}
            className={mention.status !== EXCLUDE ?
              cx(styles["un-diagonal-section"], styles["un-diagonal-mention"])
              : ""}
            onClick={this.openSourceVideo(mention)}
          >
            {
              mentionGroup.currentLoc.map((loc, index) => (
                <TableCell className={styles["margin-grouping"]} key={`${loc} - ${index.toString()}`}>
                  {""}
                </TableCell>
              ))
            }
            <TableCell className={styles["table-checkbox"]}>
              <Checkbox
                checked={_.includes(selected, mention.gen_key)}
                onClick={this.handleSelectCheckbox(mention.gen_key)}
                color="primary"
                className={classes.checkbox}
              />
            </TableCell>
            {Object.keys(selectHeaderMaps).map(headerKey => {
              let mentionItem = mention[headerKey]
              if (groupByArr.filter(item => item.groupBy === headerKey).length) { return }
              if (headerKey === 'mention_name' && !mention[headerKey]) {
                mentionItem = 'N/A';
              }
              if (headerKey === "media_type" && mention[headerKey] === VIDEO) {
                mentionItem = <Videocam />;
                mention.type_media = 2
              }
              if (headerKey === "media_type" && mention[headerKey] === AUDIO) {
                mentionItem = <Mic />;
                mention.type_media = 1
              }
              if (headerKey === "airtime") {
                const time = mention[headerKey]
                  ? format(mention[headerKey], "YYYY-MM-DD hh:mm:ss")
                  : "N/A";
                mentionItem = time;
              }
              if(headerKey === "status_reassign" && mention[headerKey] === REASSIGNED) {
                mentionItem =  <Tooltip
                                    classes={{ tooltip: classes.customTooltip }}
                                    title="Move back to Live Reads"
                                    disableFocusListener
                                >
                                    <ReplyIcon onClick={this.moveBackReassigned(mention)} className={styles.reply} />
                                </Tooltip>
              }
              if(headerKey === "status_reassign" && (mention[headerKey] !== REASSIGNED || mention["status"] === EXCLUDE)) {
                mentionItem = "";
              }
              return (
                <TableCell
                  key={headerKey}
                  className={styles[`table-${headerKey}`]}
                >
                  {mentionItem}
                </TableCell>
              );
            })}
            <TableCell style={{ textAlign: 'right' }} className={styles["table-actions"]}>
              {
                isReassignedMention
                &&
                <Tooltip
                  classes={{ tooltip: classes.customTooltip }}
                  title="Reassign  ⌘/Ctrl + R"
                  disableFocusListener
                >
                  <Shuffle className={cx(styles["item-option"])} onClick={this.handleClickReassignMention([mention.gen_key])} />
                </Tooltip>
              }
              {
                mention.status === EXCLUDE &&
                <Tooltip
                  classes={{ tooltip: classes.customTooltip }}
                  title="Include  ⌘/Ctrl + Q"
                  disableFocusListener
                >
                  <Visibility className={cx(styles["item-option"])} onClick={this.handleToggleItem(mention.gen_key, 1)} />
                </Tooltip>
              }
              {
                mention.status !== EXCLUDE &&
                <Tooltip
                  classes={{ tooltip: classes.customTooltip }}
                  title="Exclude  ⌘/Ctrl + X"
                  disableFocusListener
                >
                  <VisibilityOff className={cx(styles["item-option"])} onClick={this.handleToggleItem(mention.gen_key, 2)} />
                </Tooltip>
              }
              { showMediaPlayer &&
                (mediaMentionId === mention.mention_id
                  ?
                  <ExpandLess />
                  :
                  <ExpandMore />
                )
              }
            </TableCell>
          </TableRow>
          { mediaMentionId && showMediaPlayer &&
              mediaMentionId === mention.mention_id && (
                <TableRow id={`${mention.media_id}-media`} className={styles["un-diagonal-section"]}>
                  <TableCell colSpan={Object.keys(selectHeaderMaps).length + 2} className={styles["no-source-data"]}>
                    { mediaMention
                    ?
                    <PlayerMedia
                      mediaMention={mediaMention}
                      mediaMentionId={mediaMentionId}
                    />
                    :
                    <span>No Source Data</span>
                    }
                  </TableCell>
                </TableRow>
          )}
        </Fragment>
      )
    })
  }

  handleOpenMentionGroup = group => event => {
    const { dataAfterGroup } = this.state;
    const newData = this.toggleGroup(dataAfterGroup, group.currentLoc);
    this.setState({
      dataAfterGroup: newData,
    })
  }

  toggleGroup = (data, currentLoc) => {
    let dataNew = [...data];
    let tmp = [...dataNew];
    for (let i = 0; i < currentLoc.length - 1; i++) {
      tmp = tmp[currentLoc[i]].groupData;
    }
    tmp[currentLoc[currentLoc.length - 1]].isOpen = !tmp[currentLoc[currentLoc.length - 1]].isOpen;
    return dataNew;
  }

  moveBackReassigned = (mention) => event => {
    event.stopPropagation();
    this.props.moveBackReassigned(mention);
  }

  dataInvalidCheck = () => {
    const { mentions } = this.props;
    let invalidInfo = "";
    for ( let i = 0; i < mentions.length; i++) {
      if (!mentions[i].gen_key) {
        invalidInfo = "Data is invalid";
        break;
      }
    }
    return invalidInfo
  }

  render() {
    const {
      headerMaps = [],
      mentions,
      changeDateRange,
      classes,
      detailUrl,
      orderBy,
      order,
      handleSortMention,
      id,
      updateSummaryDrillDownSaga,
      paramGetData,
      roles,
      ...props
    } = this.props;
    const {
      selected,
      mentionScrollToShow,
      hasMore,
      groupByArr,
      dataAfterGroup,
      mediaMention,
      mediaMentionId,
      mentionsToReassign
    } = this.state;
    const rowCount = mentions.length;
    const isIndeterminate = selected.length > 0 && selected.length < mentions.length;
    const isReassigned = detailUrl.adType && detailUrl.adType === 'Live Reads';
    const isSelectedAbleToReassign = this.getIsSelectedAbleToReassign();
    const selectedAllStatus = this.getSelectAllStatus();
    const invalidInfo = this.dataInvalidCheck();

    const selectHeaderMaps = ((id === ADTYPE_CHART_ID || id === ADVISIT_CHART_ID) && isReassigned) ? {..._.omit(headerMaps, ["status_reassign"])} : headerMaps;
    const showMediaPlayer = checkRole(roles, DISCOVERY_EDITOR);
    return (
      <div data-test="summaryDrillDown">
        {invalidInfo.length > 0 ? (
          <div style={{ marginTop: '20px' }}>{invalidInfo}</div>
        ) : (
          <div>
            <div className={styles['table-action']}>
              <div
                className={cx(styles['area-drop'])}
                onDrop={this.dropToGroupMention}
                onDragOver={this.handleDropToGroupMentionDrag}
              >
                {groupByArr.length === 0
                  ? 'Drag a column header here to group by that column'
                  : groupByArr.map((groupByItem, index) => (
                      <Button
                        className={classes.sortByButton}
                        key={groupByItem.groupBy}
                        onClick={this.handleSortMentionGrouped(
                          groupByItem.groupBy
                        )}
                      >
                        {headerMaps[groupByItem.groupBy]}
                        {groupByItem.sortBy === 'desc' ? (
                          <ArrowDownward />
                        ) : (
                          <ArrowUpward />
                        )}
                        <Cancel
                          onClick={this.handleClickCloseGroupByButton(
                            groupByItem.groupBy
                          )}
                        />
                      </Button>
                    ))}
              </div>
              <div
                className={cx(
                  styles['table-option'],
                  selected.length < 1 ? styles['table-action-hide'] : ''
                )}
              >
                <IconButton className={styles['arrow-back']}>
                  <ArrowBack onClick={this.handleBackAllCheck} />
                </IconButton>
                <span data-test="countSelected">{selected.length} Selected</span>
                {isSelectedAbleToReassign && (
                  <Tooltip
                    classes={{ tooltip: classes.customTooltip }}
                    title="Reassign  ⌘/Ctrl + R"
                    disableFocusListener
                  >
                    <IconButton
                      onClick={this.handleClickReassignMention(selected)}
                    >
                      <Shuffle />
                    </IconButton>
                  </Tooltip>
                )}
                {selectedAllStatus !== EXCLUDE && (
                  <Tooltip
                    classes={{ tooltip: classes.customTooltip }}
                    title="Exclude  ⌘/Ctrl + X"
                    disableFocusListener
                  >
                    <IconButton onClick={this.handleClickItemsExclude(2)}>
                      <VisibilityOff />
                    </IconButton>
                  </Tooltip>
                )}
                {selectedAllStatus !== INCLUDE && (
                  <Tooltip
                    classes={{ tooltip: classes.customTooltip }}
                    title="Include  ⌘/Ctrl + Q"
                    disableFocusListener
                  >
                    <IconButton>
                      <Visibility onClick={this.handleClickItemsExclude(1)} />
                    </IconButton>
                  </Tooltip>
                )}
              </div>
            </div>
            {groupByArr.length === 0 ? (
              <div className={styles['tableWrapper']}>
                <div className={styles['tableScroll']}>
                  <InfiniteScroll
                    dataLength={mentionScrollToShow.length}
                    next={this.getMoreMentions}
                    hasMore={hasMore}
                    height={600}
                    style={{
                      height: 'calc(100vh - 300px)'
                    }}
                  >
                    <Table className={cx(styles['table'])}>
                      <TableHead>
                        <TableRow style={{ height: 0 }}>
                          {groupByArr.map(item => (
                            <div
                              className={cx(
                                styles['margin-grouping'],
                                styles['table-cell']
                              )}
                              key={item.groupBy}
                            >
                              {''}
                            </div>
                          ))}
                          <TableCell
                            className={cx(
                              styles['table-checkbox'],
                              styles['table-cell']
                            )}
                          >
                            <Checkbox
                              indeterminate={isIndeterminate}
                              checked={selected.length === rowCount}
                              onChange={this.handleSelectAllClick}
                              color="primary"
                              className={cx(
                                styles['tableCheckbox'],
                                classes.tableCheckbox
                              )}
                              data-test="selectAllBtn"
                            />
                          </TableCell>
                          {Object.keys(selectHeaderMaps).map(key => {
                            if (
                              groupByArr.filter(item => item.groupBy === key)
                                .length === 0
                            ) {
                              return (
                                <TableCell
                                  key={`row-${key}`}
                                  className={cx(
                                    styles[`table-${key}`],
                                    styles['table-cell']
                                  )}
                                >
                                  <div
                                    className={styles['table-header-item']}
                                    onClick={handleSortMention(key)}
                                  >
                                    <div
                                      draggable={key !== 'status_reassign'}
                                      onDragStart={this.onDragToGroupMentionStart(
                                        key
                                      )}
                                      id={`key-${key}`}
                                      style={{ transform: 'translate(0, 0)' }}
                                    >
                                      {headerMaps[key]}
                                      {key === orderBy &&
                                        (order === 'desc' ? (
                                          <ArrowDownward
                                            className={cx(classes.arrowIcon)}
                                          />
                                        ) : (
                                          <ArrowUpward
                                            className={cx(classes.arrowIcon)}
                                          />
                                        ))}
                                    </div>
                                  </div>
                                </TableCell>
                              );
                            }
                          })}
                          <TableCell
                            className={cx(
                              styles['table-actions'],
                              styles['table-cell']
                            )}
                          >
                            {''}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className={styles['diagonal-section']}>
                        {mentionScrollToShow.map((mention, index) => {
                          const isReassignedMention =
                            mention.ads_type_id === AD_TYPE_ID['Live Reads'] &&
                            mention.status !== EXCLUDE;
                          return (
                            <Fragment key={mention.mention_id}>
                              <TableRow
                                className={
                                  mention.status !== EXCLUDE
                                    ? cx(
                                        styles['un-diagonal-section'],
                                        styles['un-diagonal-mention']
                                      )
                                    : ''
                                }
                                onClick={this.openSourceVideo(mention)}
                              >
                                <TableCell className={styles['table-checkbox']}>
                                  <Checkbox
                                    checked={_.includes(
                                      selected,
                                      mention.gen_key
                                    )}
                                    onClick={this.handleSelectCheckbox(
                                      mention.gen_key
                                    )}
                                    color="primary"
                                    className={classes.checkbox}
                                  />
                                </TableCell>
                                {Object.keys(selectHeaderMaps).map(
                                  headerKey => {
                                    let mentionItem = mention[headerKey];
                                    if (
                                      headerKey === 'mention_name' &&
                                      !mention[headerKey]
                                    ) {
                                      mentionItem = 'N/A';
                                    }
                                    if (
                                      headerKey === 'media_type' &&
                                      mention[headerKey] === VIDEO
                                    ) {
                                      mentionItem = <Videocam />;
                                      mention.type_media = 2;
                                    }
                                    if (
                                      headerKey === 'media_type' &&
                                      mention[headerKey] === AUDIO
                                    ) {
                                      mentionItem = <Mic />;
                                      mention.type_media = 1;
                                    }
                                    if (
                                      headerKey === 'status_reassign' &&
                                      mention[headerKey] === REASSIGNED
                                    ) {
                                      mentionItem = (
                                        <Tooltip
                                          classes={{
                                            tooltip: classes.customTooltip
                                          }}
                                          title="Move back to Live Reads"
                                          disableFocusListener
                                        >
                                          <ReplyIcon
                                            onClick={this.moveBackReassigned(
                                              mention
                                            )}
                                            className={styles.reply}
                                          />
                                        </Tooltip>
                                      );
                                    }

                                    if (headerKey === 'stationLocalTime') {
                                      const stationLocalTime =
                                        mention['stationLocalTime'];
                                      mentionItem = moment(
                                        stationLocalTime
                                      ).format('MM/DD/YY hh:mm A');
                                    }

                                    if (
                                      headerKey === 'status_reassign' &&
                                      (mention[headerKey] !== REASSIGNED ||
                                        mention['status'] === EXCLUDE)
                                    ) {
                                      mentionItem = '';
                                    }
                                    return (
                                      <TableCell
                                        key={headerKey}
                                        className={styles[`table-${headerKey}`]}
                                      >
                                        <div>{mentionItem}</div>
                                      </TableCell>
                                    );
                                  }
                                )}
                                <TableCell
                                  style={{ textAlign: 'right' }}
                                  className={styles['table-actions']}
                                >
                                  {isReassignedMention && (
                                    <Tooltip
                                      classes={{
                                        tooltip: classes.customTooltip
                                      }}
                                      title="Reassign  ⌘/Ctrl + R"
                                      disableFocusListener
                                    >
                                      <Shuffle
                                        className={cx(styles['item-option'])}
                                        onClick={this.handleClickReassignMention(
                                          [mention.gen_key]
                                        )}
                                      />
                                    </Tooltip>
                                  )}
                                  {mention.status === EXCLUDE && (
                                    <Tooltip
                                      classes={{
                                        tooltip: classes.customTooltip
                                      }}
                                      title="Include  ⌘/Ctrl + Q"
                                      disableFocusListener
                                    >
                                      <Visibility
                                        className={cx(styles['item-option'])}
                                        onClick={this.handleToggleItem(
                                          mention.gen_key,
                                          1
                                        )}
                                      />
                                    </Tooltip>
                                  )}
                                  {mention.status !== EXCLUDE && (
                                    <Tooltip
                                      classes={{
                                        tooltip: classes.customTooltip
                                      }}
                                      title="Exclude  ⌘/Ctrl + X"
                                      disableFocusListener
                                    >
                                      <VisibilityOff
                                        className={cx(styles['item-option'])}
                                        onClick={this.handleToggleItem(
                                          mention.gen_key,
                                          2
                                        )}
                                      />
                                    </Tooltip>
                                  )}
                                  {showMediaPlayer &&
                                    (mediaMentionId === mention.mention_id ? (
                                      <ExpandLess />
                                    ) : (
                                      <ExpandMore />
                                    ))}
                                </TableCell>
                              </TableRow>
                              {mediaMentionId &&
                                showMediaPlayer &&
                                mediaMentionId === mention.mention_id && (
                                  <TableRow
                                    id={`${mention.media_id}-media`}
                                    className={styles['un-diagonal-section']}
                                  >
                                    <TableCell
                                      colSpan={
                                        Object.keys(selectHeaderMaps).length + 2
                                      }
                                      className={styles['no-source-data']}
                                    >
                                      {mediaMention ? (
                                        <PlayerMedia
                                          mediaMention={mediaMention}
                                          mediaMentionId={mediaMentionId}
                                        />
                                      ) : (
                                        <span>No Source Data</span>
                                      )}
                                    </TableCell>
                                  </TableRow>
                                )}
                            </Fragment>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </InfiniteScroll>
                </div>
              </div>
            ) : (
              <div className={styles['tableWrapper']}>
                <div className={styles['tableScroll']}>
                  <Table className={cx(styles['table-group'])}>
                    <TableHead>
                      <TableRow style={{ height: 0 }}>
                        {groupByArr.map(item => (
                          <div
                            className={cx(
                              styles['margin-grouping'],
                              styles['table-cell']
                            )}
                            key={item.groupBy}
                          >
                            {''}
                          </div>
                        ))}
                        <TableCell
                          className={cx(
                            styles['table-checkbox'],
                            styles['table-cell']
                          )}
                        >
                          <Checkbox
                            indeterminate={isIndeterminate}
                            checked={selected.length === rowCount}
                            onChange={this.handleSelectAllClick}
                            color="primary"
                            className={cx(
                              styles['tableCheckbox'],
                              classes.tableCheckbox
                            )}
                          />
                        </TableCell>
                        {Object.keys(selectHeaderMaps).map(key => {
                          if (
                            groupByArr.filter(item => item.groupBy === key)
                              .length === 0
                          ) {
                            return (
                              <TableCell
                                key={`row-${key}`}
                                className={cx(
                                  styles[`table-${key}`],
                                  styles['table-cell']
                                )}
                              >
                                <div
                                  className={styles['table-header-item']}
                                  onClick={handleSortMention(key)}
                                >
                                  <div
                                    draggable={key !== 'status_reassign'}
                                    onDragStart={this.onDragToGroupMentionStart(
                                      key
                                    )}
                                    id={`key-${key}`}
                                  >
                                    {selectHeaderMaps[key]}
                                    {key === orderBy &&
                                      (order === 'desc' ? (
                                        <ArrowDownward
                                          className={cx(classes.arrowIcon)}
                                        />
                                      ) : (
                                        <ArrowUpward
                                          className={cx(classes.arrowIcon)}
                                        />
                                      ))}
                                  </div>
                                </div>
                              </TableCell>
                            );
                          }
                        })}
                        <TableCell
                          className={cx(
                            styles['table-actions'],
                            styles['table-cell']
                          )}
                        >
                          {''}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className={styles['diagonal-section']}>
                      {dataAfterGroup.map((mentionGroup, index) => (
                        <Fragment key={index.toString()}>
                          <TableRow className={styles['un-diagonal-section']}>
                            {mentionGroup.currentLoc.map((loc, subIndex) => (
                              <TableCell
                                key={subIndex.toString()}
                                className={styles['margin-grouping']}
                              >
                                {''}
                              </TableCell>
                            ))}
                            <TableCell
                              colSpan={Object.keys(selectHeaderMaps).length + 2}
                              className={styles['table-group-title']}
                            >
                              <span className={styles['table-checkbox']}>
                                <IconButton
                                  onClick={this.handleOpenMentionGroup(
                                    mentionGroup
                                  )}
                                >
                                  {mentionGroup.isOpen ? (
                                    <KeyboardArrowDown />
                                  ) : (
                                    <ChevronRight />
                                  )}
                                </IconButton>
                              </span>
                              <span>
                                {`${
                                  selectHeaderMaps[mentionGroup.groupBy.groupBy]
                                }: ${mentionGroup.groupByValue}`}
                              </span>
                            </TableCell>
                          </TableRow>
                          {this.renderMentionGrouped(mentionGroup)}
                        </Fragment>
                      ))}
                      {this.state.defaultValue.map((mentionGroup, index) => (
                        <Fragment key={index.toString()}>
                          <TableRow
                            className={
                              styles[('un-diagonal-section', 'color-trans')]
                            }
                          >
                            {mentionGroup.currentLoc.map((loc, subIndex) => (
                              <TableCell
                                key={subIndex.toString()}
                                className={
                                  styles[('margin-grouping', 'color-trans')]
                                }
                              >
                                {''}
                              </TableCell>
                            ))}
                            <TableCell
                              colSpan={Object.keys(selectHeaderMaps).length + 2}
                              className={
                                styles[('table-group-title', 'color-trans')]
                              }
                            >
                              <span
                                className={
                                  styles[('table-checkbox', 'color-trans')]
                                }
                              >
                                <IconButton
                                  disabled
                                  className={styles['color-trans']}
                                >
                                  {mentionGroup.isOpen ? (
                                    <KeyboardArrowDown
                                      className={styles['color-trans']}
                                    />
                                  ) : (
                                    <ChevronRight
                                      className={styles['color-trans']}
                                    />
                                  )}
                                </IconButton>
                              </span>
                              <span className={styles['color-trans']}>
                                {`${
                                  selectHeaderMaps[mentionGroup.groupBy.groupBy]
                                }: ${mentionGroup.groupByValue}`}
                              </span>
                            </TableCell>
                          </TableRow>
                          {this.renderMentionGroupedDefault(mentionGroup)}
                        </Fragment>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </div>
            )}

            <ReassignModal
              open={this.state.openReassignModal}
              handleCloseReassignDialog={this.handleCloseReassignDialog}
              changeDateRange={changeDateRange}
              detailUrl={detailUrl}
              handleReassignItems={this.handleReassignItems}
              mentionsToReassign={mentionsToReassign}
              updateSummaryDrillDownSaga={updateSummaryDrillDownSaga}
              paramGetData={paramGetData}
              {...props}
            />
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(SUMMARY_STYLES)(SummaryDrillDown);
